$(document).ready(function() {
   function updateCountdown() {
    // Get the current time in the London timezone
    var now = new Date();
    var londonTime = new Date(now.toLocaleString("en-US", { timeZone: "Europe/London" }));

    // Set the target time to 5pm in the London timezone
    var targetTime = new Date(londonTime);
    targetTime.setHours(14, 0, 0, 0);

    // Calculate the time remaining until the target time
    var timeRemaining = targetTime - londonTime;

    // Show the countdown only when there are 5 hours remaining
    if (timeRemaining >= 0 && timeRemaining <= 5 * 60 * 60 * 1000) {
        var hours = Math.floor((timeRemaining / (1000 * 60 * 60)) % 24);
        var minutes = Math.floor((timeRemaining / (1000 * 60)) % 60);
        var seconds = Math.floor((timeRemaining / 1000) % 60);

        // Update the countdown display
        $(".hours").text(hours.toString().padStart(2, '0'));
        $(".minutes").text(minutes.toString().padStart(2, '0'));
        $(".seconds").text(seconds.toString().padStart(2, '0'));
        $(".time-counter-uk").attr("style", "display: block");
    } else {
        // Hide the countdown when it's not within the specified range
        $(".time-counter-uk").attr("style", "display: none !important");
    }
  }

  // Call updateCountdown initially
  updateCountdown();
  
  // Update the countdown every second
  setInterval(updateCountdown, 1000);
});

$(document).ready(function() {
  function updateCountdownAustralia() {
    // Get the current time in the Australia/Sydney timezone
    var now_au = new Date();
    var australiaTime = new Date(now_au.toLocaleString("en-US", { timeZone: "Australia/Sydney" }));

    // Set the target time to 3pm in the Australia/Sydney timezone
    var targetTime_au = new Date(australiaTime);
    targetTime_au.setHours(15, 0, 0, 0); // Adjust the target time as needed

    // Calculate the time remaining until the target time
    var timeRemaining_au = targetTime_au - australiaTime;

    // Show the countdown only when there are 5 hours remaining
    if (timeRemaining_au >= 0 && timeRemaining_au <= 5 * 60 * 60 * 1000) {
      var hours_au = Math.floor((timeRemaining_au / (1000 * 60 * 60)) % 24);
      var minutes_au = Math.floor((timeRemaining_au / (1000 * 60)) % 60);
      var seconds_au = Math.floor((timeRemaining_au / 1000) % 60);

      // Update the countdown display
      $(".hours_au").text(hours_au.toString().padStart(2, '0'));
      $(".minutes_au").text(minutes_au.toString().padStart(2, '0'));
      $(".seconds_au").text(seconds_au.toString().padStart(2, '0'));
      $(".time-counter-au").attr("style", "display: block");
    } else {
      // Hide the countdown when it's not within the specified range
      $(".time-counter-au").attr("style", "display: none !important");
    }
  }

  // Call updateCountdownAustralia initially
  updateCountdownAustralia();

  // Update the countdown every second
  setInterval(updateCountdownAustralia, 1000);
});
